import { render, staticRenderFns } from "./AppCheckSms.vue?vue&type=template&id=351c06f7&"
import script from "./AppCheckSms.vue?vue&type=script&lang=js&"
export * from "./AppCheckSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports